import 'core-js/modules/es.string.replace-all';
import Vue from 'vue';
import GrooveUIKitV2 from '../../../../groove-ui-kit-v2/src/vue2/groove-ui-kit';
import '../../../../groove-ui-kit-v2/src/styles/groove-ui-kit.css';
import './studio.css';

Vue.use(GrooveUIKitV2);
